import * as React from 'react';

const StorageSmall = () => (
  <svg
    width={51}
    height={43}
    viewBox="0 0 51 43"
    strokeWidth={1}
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <polygon
      stroke="none"
      fill="#E7EBF6"
      points="4.25 41.526 47.224 41.526 47.224 3.833 4.25 3.833"
    />
    <path
      stroke="none"
      fill="#3A427C"
      d="M47.427,6.583 C47.41,7.049 47.396,7.512 47.393,7.969 C47.391,8.185 47.405,8.387 47.426,8.584 L4.162,8.584 L4.162,6.583 L47.427,6.583 Z"
      opacity={0.2}
    />
    <polygon strokeWidth={2} points="4.25 41.25 46.75 41.25 46.75 3.75 4.25 3.75" />
    <path strokeWidth={2} d="M1,41.25 L50,41.25" />
    <polygon
      stroke="none"
      fill="#1D2C61"
      points="11.338 41.526 40.138 41.526 40.138 15.953 11.338 15.953"
    />
    <polygon strokeWidth={2} points="11.25 41.25 39.75 41.25 39.75 13.75 11.25 13.75" />
    <polygon
      stroke="none"
      fill="#677BC5"
      points="11.338 28.888 40.138 28.888 40.138 11.953 11.338 11.953"
    />
    <polygon
      stroke="none"
      fill="#E7EBF6"
      points="11.338 22.888 40.138 22.888 40.138 11.453 11.338 11.453"
    />
    <polygon strokeWidth={2} points="11.25 29.25 39.75 29.25 39.75 11.25 11.25 11.25" />
    <path stroke="none" fill="#FFFFFF" d="M12.837,19.562 L38.638,19.562 L12.837,19.562 Z" />
    <path d="M11.337,15.25 L39.637,15.25" />
    <path stroke="none" fill="#FFFFFF" d="M12.837,23.171 L38.638,23.171 L12.837,23.171 Z" />
    <path d="M11.337,19.25 L39.637,19.25" />
    <path d="M11.337,23.25 L39.637,23.25" />
    <path strokeWidth={2} d="M24,26.25 L27,26.25 L24,26.25 Z" />
    <polygon stroke="none" fill="#3A427C" points="2.25 5.833 49.224 5.833 49.224 1.25 2.25 1.25" />
    <polygon strokeWidth={2} points="2.25 6.25 48.75 6.25 48.75 1.25 2.25 1.25" />
  </svg>
);

export default StorageSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/storage-small.js